export const routes = [

  {
    path: "/login",
    name: "login",
    meta: {
      title: "ورود",
      auth: false
    },
    component: () => import("@/views/Login/Login.vue"),
  },
  {
    path: "/verify",
    name: "verify",
    meta: {
      title: "تکمیل ورود یا ثبت نام",
      auth: false
    },
    component: () => import("@/views/Verify/Verify.vue"),
  },
  {
    path: "/",
    name: "home",
    meta: {
      title: "صفحه اصلی",
      auth: false
    },
    component: () => import("@/views/Home/index.vue"),
  },
  {
    path: "/agancy",
    name: "agancy",
    meta: {
      title: "آژانس های گردش گری",
      auth: false
    },
    component: () => import("@/views/Agancy/list.vue"),
  },
  {
    path: "/agancy/:id",
    name: "agancy single",
    meta: {
      title: "آژانس گردش گری",
      auth: false
    },
    component: () => import("@/views/Agancy/new-single.vue"),
  },
  {
    path: "/packages",
    name: "packages",
    meta: {
      title: "پکیج های کردشگری",
      auth: false
    },
    component: () => import("@/views/Packages/index.vue"),
  },
  {
    path: "/packages/:id",
    name: "packages-single",
    meta: {
      title: "پکیج کردشگری",
      auth: false
    },
    component: () => import("@/views/Packages/single.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    meta: {
      title: "پروفایل کاربری",
      auth: true
    },
    component: () => import("@/views/Profile/index.vue"),
  },
  {
    path: "/profile/history",
    name: "profile-history",
    meta: {
      title: "سوابق خرید های من",
      auth: true
    },
    component: () => import("@/views/Profile/History/History.vue"),
  },
  {
    path: "/profile/avatar",
    name: "profile-avatar",
    meta: {
      title: "تغییر عکس پروفایل",
      auth: true
    },
    component: () => import("@/views/Profile/Avatar/Avatar.vue"),
  },
  {
    path: "/profile/payments",
    name: "payments",
    props:true,
    meta: {
      title: "سوابق اعتبار شما",
      auth: true,
    },
    component: () => import("@/views/Profile/Wallet/Wallet.vue"),
  },
  {
    path: "/live",
    name: "live",
    meta: {
      title: "پخش رویداد ها و کنسرت های آنلاین کیشوتو",
      auth: false
    },
    component: () => import("@/views/Live/Live.vue"),
  },
  {
    path: "/events",
    name: "events",
    meta: {
      title: "رویداد های کیشوتو",
      auth: false
    },
    component: () => import("@/views/Events/Events.vue"),
  },
  {
    path: "/events/computer-games",
    name: "computer-games-events",
    meta: {
      title: "مسابقات بازی های رایانه ای",
      auth: false
    },
    component: () => import("@/views/Events/ComputerGames.vue"),
  },
  {
    path: "/events/beach-games",
    name: "beach-events",
    meta: {
      title: "بازی های ساحلی",
      auth: false
    },
    component: () => import("@/views/Events/BeachGames.vue"),
  }
  ,
  {
    path: "/restaurants",
    name: "restaurants",
    meta: {
      title: "رستوران ها و فست فود ها",
      auth: false
    },
    component: () => import("@/views/Restaurants/Restaurants.vue"),
  },
  {
    path: "/restaurant/:id",
    name: "restaurant",
    meta: {
      title: "رستوران ها و فست فود ها",
      auth: false
    },
    component: () => import("@/views/Restaurants/single.vue"),
  },
  {
    path: "/payment",
    name: "payment",
    props:true,
    meta: {
      title: "پرداخت",
      auth: true,
    },
    component: () => import("@/views/Payment/Payment.vue"),
  },
  {
    path: "/calendar",
    name: "calendar",
    props:true,
    meta: {
      title: "تقویم",
      auth: false,
    },
    component: () => import("@/views/Calendar/Calendar.vue"),
  },
  {
    path: "/malls",
    name: "malls",
    props:true,
    meta: {
      title: "مراکز خرید",
      auth: false,
    },
    component: () => import("@/views/Malls/index.vue"),
  },
  {
    path: "/malls/:id",
    name: "mall-single",
    props:true,
    meta: {
      title: "مرکز خرید",
      auth: false,
    },
    component: () => import("@/views/Malls/single.vue"),
  },
  {
    path: "/shop/:id",
    name: "shop-single",
    props:true,
    meta: {
      title: "فروشگاه",
      auth: false,
    },
    component: () => import("@/views/Shop/single.vue"),
  },
  {
    path: "/asnaf/",
    name: "asnaf",
    props:true,
    meta: {
      title: "اصناف",
      auth: false,
    },
    component: () => import("@/views/Asnaf/index.vue"),
  },
  {
    path: "/asnaf/:id",
    name: "asnaf-single",
    props:true,
    meta: {
      title: "صفحه تکی اصناف",
      auth: false,
    },
    component: () => import("@/views/Asnaf/single.vue"),
  },
  {
    path: "/asnaf/shop/:id",
    name: "asnaf-shop-single",
    props:true,
    meta: {
      title: "صفحه تکی فروشگاه",
      auth: false,
    },
    component: () => import("@/views/Asnaf/shop-single.vue"),
  },
  {
    path: "/asnaf/shop/:id",
    name: "asnaf-shop-single",
    props:true,
    meta: {
      title: "صفحه تکی فروشگاه",
      auth: false,
    },
    component: () => import("@/views/Asnaf/shop-single.vue"),
  },
  {
    path: "/introduce/:xcode",
    name: "introduce",
    props:true,
    meta: {
      title: "صفحه معرفی با qrcode",
      auth: false,
    },
    component: () => import("@/views/Introduce/Introduce"),
  }
  ,{
    path: "/voting",
    name: "voting",
    meta: {
      title: "نظرسنجی کیشوتو",
      auth: false
    },
    component: () => import("@/views/Voting/list.vue"),
  },
  {
    path: "/voting/:id",
    name: "voting single",
    meta: {
      title: "نظرسنجی استعداد یابی",
      auth: false
    },
    component: () => import("@/views/Voting/single.vue"),
  },
  {
    path: "/elections/:id",
    name: "elections",
    meta: {
      title: "نظرسنجی ",
      auth: true
    },
    component: () => import("@/views/Voting/candidates.vue"),
  },
  {
    path: "/talent/:id",
    name: "talent single",
    meta: {
      title: "نظرسنجی استعداد یابی",
      auth: true
    },
    component: () => import("@/views/Voting/talent.vue"),
  },
  {
    path: "/candidate/:id",
    name: "candidate-single",
    meta: {
      title: "نظرسنجی کاندیدا",
      auth: true
    },
    component: () => import("@/views/Voting/single-candidate.vue"),
  },
  {
    path: "/tornoments/",
    name: "tornoments",
    meta: {
      title: "مسابقات چند جانبه",
      auth: false
    },
    component: () => import("@/views/Tornoments/Tornoment.vue"),
  },
  {
    path: "/tornoment/:id",
    name: "tornoment-single",
    meta: {
      title: "مسابقات چند جانبه",
      auth: false
    },
    component: () => import("@/views/Tornoments/TornomentSingle.vue"),
  },
  {
    path: '*',
    name: 'catchAll',
    component: () => import("@/views/Home/index.vue"),
  },
  {
    path: "/index.html",
    redirect: "/"
  }
];
